module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would like to offer my very sincere thanks and deep appreciation to everyone at New Page Books and Career Press, particularly Michael Pye, Laurie Kelly-Pye, Kirsten Dalley, Roger Sheety, Gina Talucci, Jeff Piasky, and Adam Schwartz; and to all the staff at Warwick Associates for their fine promotion and publicity campaigns. I would also like to say a very big thank you to my literary agent, Lisa Hagan, for all her hard work and help.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 69
// module chunks = 0